<template>
  <div>
    <div class="zw_display">
      <div class="tabcontent clearfix" style="display: block">
        <!-- 算法 -->
        <div class="tabcontent clearfix">
          <div class="position">
            <div class="photo">
              <img src="@/assets/images/joinus/sftp1.png" />
            </div>
            <div class="detail">
              <h5>算法工程师 （1-2名）</h5>
              <h6>工作地点：武汉</h6>
              <h6 class="nbot">职位描述：</h6>
              <ul class="skills">
                <li>1.语音降噪算法开发方向： 在已有的抑噪和语音增强算法基础上优化设计适用于各种场景下的语音信号采样和降噪算法，为语音识别提供高质量的音频信号；</li>
                <li>2.语音算法开发方向：在已有的近二十种语音模型算法基础上针对特定场景进行算法优化开发，支撑产品开发工程师进行场景化产品开发；</li>
                <li>
                  3.机器学习算法开发方向：针对样本数据和语音模型，优化训练算法以提高模型训练速度和拟合精度，获得全局最优的模型参数；设计不同于传统的语音分类方法，研究如何利用神经网络进行语音识别和
                  语义理解，并进行工程应用开发。
                </li>
              </ul>
              <h6 class="nbot">任职要求：</h6>
              <ul class="skills">
                <li>1.计算机科学、模式识别、控制理论与控制工程相关专业硕士毕业生，具有3年以上工作经验；</li>
                <li>2.掌握多元统计分析、数据挖掘、机器学习、神经网络理论；</li>
                <li>3.熟练掌握Python和C++程序语言；</li>
                <li>4.有较强的算法基础和工程实际经验；</li>
                <li>5.善于思考，具有独立解决问题的能力；</li>
                <li>6.工作踏实上进，具有良好的团队合作精神。</li>
              </ul>
            </div>
          </div>

          <div class="position">
            <div class="photo">
              <img src="@/assets/images/joinus/sftp3.png" />
            </div>
            <div class="detail">
              <h5>算法研究员 （1-2名）</h5>
              <h6>工作地点：武汉</h6>
              <h6 class="nbot">职位描述：</h6>
              <ul class="skills">
                <li>1.模式识别与自然语言处理方向：在本公司已有的语音、图像识别和自然语言处理算法研发成果基础上，承担公司面向国防与公共安全领域情绪识别、多模态识别、语音交互、声学探测等领域的创新研发项目；</li>
                <li>2.机器学习/数据挖掘/优化算法方向：针对特定应用场景的机器学习算法优化，大数据算法开发。</li>
              </ul>
              <h6 class="nbot">任职要求：</h6>
              <ul class="skills">
                <li>1.学历要求：211高校计算机科学、模式识别、控制理论与控制工程专业博士学位；</li>
                <li>2. 工作年限：应届毕业生或者往届均可，有工作经验者优先；</li>
                <li>3. 精通多元统计分析、数据挖掘、机器学习、神经网络理论；</li>
                <li>
                  4. 研究及项目经历：有以下软件算法研究经历（五项必有其一）
                  <ul class="padding">
                    <li>1）模式识别（语音或图像识别）；</li>
                    <li>2）自然语言处理（NLP）；</li>
                    <li>3）机器学习或大数据挖掘；</li>
                    <li>4）优化算法设计及工程应用；</li>
                    <li>5）神经网络深度学习；</li>
                  </ul>
                </li>
                <li>5.工作踏实上进，具有良好的团队合作精神。</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="tips">
        <h5>招聘流程和联系方式</h5>
        <h6>招聘流程</h6>
        <p>简历投递--电话面试--现场初试--现场复试--录用</p>
        <h6>联系方式</h6>
        <ul class="skills">
          <li>联系电话：027-81736698、13995546358</li>
          <li>简历投递邮箱：hr@dasoundgen.com</li>
          <li>地址：中国•光谷•武大科技园航域二区B3栋7楼</li>
        </ul>
      </div>

      <div class="tips">
        <h5 class="treatment">福利待遇</h5>
        <p>
          应聘者一经录用，入职当天即签订正式劳动合同（实习生签订实习协议，应届生签订三方协议），将享受包括基本工资、绩效奖金、年终奖金、五险一
          金、项目奖金、其他津（补）贴、带薪休假、在职培训、传统节日及生日礼品、年度体检等在内富有市场竞争力的薪酬福利待遇。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'research',
  data () {
    return {

    }
  }
}
</script>

<style scoped>
.tabcontent {
  width: 62.5%;
  display: block;
}
.tabcontent {
  width: 779px;
  display: block;
}
.tips {
  width: 779px;
}
.nbot {
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/aboutus/joinus/research.vue